import {Button, ImageView, Label} from 'components';
import {Ecolors, Icons} from 'constant';
import React from 'react';
import {StyleProp, ViewStyle} from 'react-native';
import {changeLanguage} from 'reducer/languages/reducer';
import {useAppDispatch, useAppSelector} from 'store/hooks';

function DropdownMultiLanguage({style}: {style?: StyleProp<ViewStyle>}) {
  const activeLanguage = useAppSelector(
    state => state.languages.activeLanguage,
  );
  const dispatch = useAppDispatch();

  const doChangeLanguage = () => {
    dispatch(
      changeLanguage(
        activeLanguage.code == 'vi'
          ? {
              code: 'en',
              name: 'EN',
              icons: Icons.english,
            }
          : {
              code: 'vi',
              name: 'VN',
              icons: Icons.vietnam,
            },
      ),
    );
  };

  return (
    <Button
      style={style}
      onPress={() => doChangeLanguage()}
      flexDirection={'row'}
      alignItems={'center'}
      justifyContent={'space-between'}
      paddingLeft={4}
      maxWidth={63}
      minWidth={55}
      borderRadius={30}
      paddingVertical={5}
      backgroundColor={Ecolors.mainColor}>
      <ImageView
        source={activeLanguage.icons || Icons.vietnam}
        height={22}
        width={22}
        resizeMode={'contain'}
      />
      <Label
        marginRight={8}
        marginLeft={4}
        size={14}
        color={Ecolors.whiteColor}
        multilanguage={false}>
        {activeLanguage.name}
      </Label>
    </Button>
  );
}

export default React.memo(DropdownMultiLanguage);
